import {
    AI_EMAIL_AGENT_BASE_ROUTE_URL,
    AI_MEETING_AGENT_BASE_ROUTE_URL,
    COMPANY_ANALYSIS_PAGE_ROUTE_URL,
    ENRICHMENT_PAGE_ROUTE_URL,
    FIND_APPS_PAGE_ROUTE_URL,
    FIND_LEADS_PAGE_ROUTE_URL,
    ACCOUNT_SIGNALS_MANAGEMENT_PAGE_URL,
    MY_LISTS_BASE_ROUTE_URL,
    SI_MANAGEMENT_ROOT_URL,
    WEBSITE_ANALYSIS_PAGE_ROUTE_URL,
} from "app/pages/sales-intelligence/constants/routes";
import type { LinkWidgetProps } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/super-agent/components/LinkWidget/LinkWidget";

const LINK_WIDGET_CONFIG: {
    [key: string]: Omit<LinkWidgetProps, "url">;
} = {
    [FIND_LEADS_PAGE_ROUTE_URL]: {
        title: "super.agent.link.widget.lead-gen.title",
        subTitle: "super.agent.link.widget.lead-gen.subtitle",
        iconName: "search-gradient",
    },
    [COMPANY_ANALYSIS_PAGE_ROUTE_URL]: {
        title: "super.agent.link.widget.company-analysis.title",
        subTitle: "super.agent.link.widget.company-analysis.subtitle",
        iconName: "company-gradient",
    },
    [WEBSITE_ANALYSIS_PAGE_ROUTE_URL]: {
        title: "super.agent.link.widget.website-analysis.title",
        subTitle: "super.agent.link.widget.website-analysis.subtitle",
        iconName: "company-gradient",
    },
    [FIND_APPS_PAGE_ROUTE_URL]: {
        title: "super.agent.link.widget.find-apps.title",
        subTitle: "super.agent.link.widget.find-apps.subtitle",
        iconName: "find-apps-gradient",
    },
    [AI_MEETING_AGENT_BASE_ROUTE_URL]: {
        title: "super.agent.link.widget.meeting-agent.title",
        subTitle: "super.agent.link.widget.meeting-agent.subtitle",
        iconName: "ai-calendar-gradient",
    },
    [AI_EMAIL_AGENT_BASE_ROUTE_URL]: {
        title: "super.agent.link.widget.email-agent.title",
        subTitle: "super.agent.link.widget.email-agent.subtitle",
        iconName: "craft-email-gradient",
    },
    [MY_LISTS_BASE_ROUTE_URL]: {
        title: "super.agent.link.widget.lists.title",
        subTitle: "super.agent.link.widget.lists.subtitle",
        iconName: "list-gradient",
    },
    [ACCOUNT_SIGNALS_MANAGEMENT_PAGE_URL]: {
        title: "super.agent.link.widget.signals-intent.title",
        subTitle: "super.agent.link.widget.signals-intent.subtitle",
        iconName: "hot-gradient",
    },
    [ENRICHMENT_PAGE_ROUTE_URL]: {
        title: "super.agent.link.widget.enrichment.title",
        subTitle: "super.agent.link.widget.enrichment.subtitle",
        iconName: "enrichment-gradient",
    },
    [SI_MANAGEMENT_ROOT_URL]: {
        title: "super.agent.link.widget.management.title",
        subTitle: "super.agent.link.widget.management.subtitle",
        iconName: "integrations-gradient",
    },
};

const extractLinksFromContent = (content: string) => {
    const linkRegex = /https:\/\/pro\.similarweb\.com\/\??#\/sales\/[^\s)]+/g;
    return content.match(linkRegex) || [];
};

const mapLinkToWidgetProps = (links: string[]) => {
    const routesToCheck = Object.keys(LINK_WIDGET_CONFIG);
    const widgets: Record<string, LinkWidgetProps> = {};

    links.forEach((link) => {
        routesToCheck.forEach((route) => {
            if (link.includes(route)) {
                widgets[route] = {
                    ...LINK_WIDGET_CONFIG[route],
                    url: link,
                };
            }
        });
    });

    return Object.values(widgets);
};

export const getLinkWidgetsFromContent = (content: string) => {
    const links = extractLinksFromContent(content);
    return mapLinkToWidgetProps(links);
};
